import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'

export  function DialogBasic({open, onClose}) {
  return (
    <>
     <Dialog open={open} onClose={() => onClose(false)}>
      <DialogTitle>¡ATENCIÓN!</DialogTitle>
      <DialogContent>
        <DialogContentText>¿Estás seguro que deseas borrar el contenido?</DialogContentText>
      </DialogContent>
      <DialogActions>       
        <Button onClick={() => onClose(true)} color="error" variant="contained">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>     
    </>
  )
}
